import { useState, useEffect } from 'react'
import Modal from 'react-modal'

Modal.setAppElement('#root')

const Clientes = () => {
  const [clientes, setClientes] = useState([])
  const [isClientModalOpen, setIsClientModalOpen] = useState(false)
  const [newClientName, setNewClientName] = useState('')
  const [clientMessage, setClientMessage] = useState('')

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: '20px',
      maxWidth: '500px',
      width: '100%'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)'
    }
  }

  const loadClientes = async () => {
    const idUsuario = localStorage.getItem('idUsuario')
    try {
      const res = await fetch(
        `https://sismoney.com/painel/database_resumo.php?idUsuario=${idUsuario}`
      )
      const data = await res.json()
      let list = []
      if (data && Array.isArray(data.clientes)) list = data.clientes
      else if (Array.isArray(data)) list = data

      // normalizar e deduplicar
      const cleaned = []
      const seen = new Set()
      list.forEach(c => {
        const nome = (c.nome || '').toString().trim()
        if (!nome) return
        const key = nome.toLowerCase()
        if (seen.has(key)) return
        seen.add(key)
        cleaned.push({ ...c, nome })
      })
      setClientes(cleaned)
    } catch (err) {
      console.error('Erro ao carregar clientes:', err)
    }
  }

  useEffect(() => {
    loadClientes()
  }, [])

  const handleAddClient = async e => {
    e && e.preventDefault()
    setClientMessage('')
    const idUsuario = localStorage.getItem('idUsuario')
    const nomeTrim = (newClientName || '').trim()
    if (!nomeTrim) {
      setClientMessage('Informe o nome do cliente')
      return
    }
    // validar duplicado localmente
    const exists = clientes.some(
      c => c.nome && c.nome.toLowerCase() === nomeTrim.toLowerCase()
    )
    if (exists) {
      setClientMessage('Já existe um cliente com esse nome')
      return
    }
    try {
      const res = await fetch(
        'https://sismoney.com/painel/database_resumo.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            resource: 'cliente',
            nome: nomeTrim,
            idUsuario
          })
        }
      )
      const result = await res.json()
      if (result.success) {
        setNewClientName('')
        setIsClientModalOpen(false)
        await loadClientes()
      } else {
        setClientMessage(result.message || 'Erro ao cadastrar cliente')
      }
    } catch (err) {
      console.error('Erro ao cadastrar cliente:', err)
      setClientMessage('Erro ao cadastrar cliente')
    }
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
          Clientes
        </h3>
        <button
          onClick={() => setIsClientModalOpen(true)}
          className="text-sm px-3 py-1 bg-green-600 text-white rounded-md"
        >
          Novo
        </button>
      </div>

      <div className="overflow-auto max-h-[60vh]">
        {clientes.length === 0 ? (
          <p className="text-sm text-gray-500">Nenhum cliente</p>
        ) : (
          <ul className="space-y-2">
            {clientes.map(c => (
              <li
                key={c.id || c.nome}
                className="p-2 rounded-md bg-gray-50 dark:bg-gray-700 text-gray-800 dark:text-gray-200"
              >
                {c.nome}
              </li>
            ))}
          </ul>
        )}
      </div>

      <Modal
        isOpen={isClientModalOpen}
        onRequestClose={() => setIsClientModalOpen(false)}
        style={customModalStyles}
        contentLabel="Cadastro de Cliente"
      >
        <h2 className="text-2xl font-bold mb-4">Cadastro de Cliente</h2>
        <form onSubmit={handleAddClient} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Nome
            </label>
            <input
              type="text"
              value={newClientName}
              onChange={e => setNewClientName(e.target.value)}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
            {clientMessage && (
              <p className="text-sm text-red-600 mt-2">{clientMessage}</p>
            )}
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={() => setIsClientModalOpen(false)}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Salvar
            </button>
          </div>
        </form>
      </Modal>
    </div>
  )
}

export default Clientes
